import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

const updateConditionChildPositionReducer = (
  state: DesignState,
  action: PayloadAction<{
    spreadIndex: number;
    childrenKey: string;
    prevIndex: number;
    newIndex: number;
    siblingIndices?: number[];
  }>,
) => {
  const { spreadIndex, childrenKey, prevIndex, newIndex, siblingIndices } = action.payload;
  const conditionGroup = state.designData?.spreads[spreadIndex]?.conditionGroup;
  if (!conditionGroup) {
    return;
  }

  const children = conditionGroup.children[childrenKey];
  if (children && siblingIndices) {
    const indices = [...new Set(siblingIndices)].sort((a, b) => a - b);
    const from = indices.indexOf(prevIndex);
    const to = indices.indexOf(newIndex);
    if (
      from < 0 ||
      to < 0 ||
      indices.some((index) => !Number.isInteger(index) || index < 0 || index >= children.length)
    ) {
      return;
    }
    const siblings = indices.map((index) => children[index]);
    const [element] = siblings.splice(from, 1);
    siblings.splice(to, 0, element);
    indices.forEach((index, position) => {
      children[index] = siblings[position];
    });
    return;
  }
  if (children) {
    const [element] = children.splice(prevIndex, 1);
    children.splice(newIndex, 0, element);
  }
};

export default updateConditionChildPositionReducer;
